import { gql } from '@apollo/client'

export const CREATE_FANTASY_LEAGUE = gql`
  mutation CreateFantasyLeague($input: CreateFantasyLeagueInput!) {
    createFantasyLeague(input: $input) {
      fantasyLeague {
        id
        name
        isPublic
        maxPlayers
        secretCode
        participantsCount
        creator {
          id
          fullName
        }
      }
      errors
    }
  }
`
